// var a = "http://192.168.0.100:8080";
export default{
  install(Vue){
    //线下
    //  Vue.prototype.header = "http://192.168.0.154:8182";
    //测试环境
    // Vue.prototype.header = "http://39.100.72.81:8182";
    //线上 正式环境
    Vue.prototype.header = "//jiujiang-dsbi.xjoycity.com/data_back";
  }
}



// WEBPACK FOOTER //
// ./src/router/httpHeard.js